import { userConstants } from "../constants/userConstants";
import { userService } from "../../services/API/userService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";
import auth from "../../services/auth";
import { Router, Route, Link } from 'react-router-dom';
import { createBrowserHistory } from 'history';

export default createBrowserHistory();

export const userActions = {
  login,
  logout,
  getUserRequest,
  getAll,
  delete: _delete,
  superAdminLogin,
  forgot_Passsword,
  reset_Passsword,
  getLoginDetailByToken
};

function login(email, password) {
  return dispatch => {
    userService.login(email, password).then(
      user => {
        dispatch(success(user));
        if (localStorage.getItem("userTypeName") == "customer") {
          history.push("/");
        } else {
          history.push("/dashboard");
        }
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function superAdminLogin(userid, usertype) {
  return dispatch => {
    userService.superAdminLogin(userid, usertype).then(
      user => {
        dispatch(success(user));
        history.push("/dashboard");
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout() {
  return dispatch => {
    userService.logout().then(
      user => {
        dispatch(success(user));
        history.push("/");
      },
      error => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function success(user) {
    return { type: userConstants.LOGOUT_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGOUT_FAILURE, error };
  }
}

function getUser() {
  return {
    type: actionTypes.USER_GET
  };
}

function getUserRequest() {
  return dispatch => {
    dispatch(request());

    userService
      .getUser()
      .then(
        user => dispatch(success(user)),
        error => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: userConstants.GET_USER_REQUEST };
  }
  function success(users) {
    return { type: userConstants.GET_USER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.GET_USER_FAILURE, error };
  }
}

function register(user) {
  return dispatch => {
    dispatch(request(user));

    userService.register(user).then(
      user => {
        dispatch(success());
        history.push("/login");
        dispatch(alertActions.success("Registration successful"));
      },
      error => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(user) {
    return { type: userConstants.REGISTER_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.REGISTER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, error };
  }
}

function getAll() {
  return dispatch => {
    dispatch(request());

    userService
      .getAll()
      .then(
        users => dispatch(success(users)),
        error => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(users) {
    return { type: userConstants.GETALL_SUCCESS, users };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return dispatch => {
    dispatch(request(id));

    userService
      .delete(id)
      .then(
        user => dispatch(success(id)),
        error => dispatch(failure(id, error.toString()))
      );
  };

  function request(id) {
    return { type: userConstants.DELETE_REQUEST, id };
  }
  function success(id) {
    return { type: userConstants.DELETE_SUCCESS, id };
  }
  function failure(id, error) {
    return { type: userConstants.DELETE_FAILURE, id, error };
  }
}

function forgot_Passsword(postData) {
  return dispatch => {
    userService.forgot_Passsword(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: userConstants.FORGOTPWD_REQUEST, data };
  }
  function success(data) {
    return { type: userConstants.FORGOTPWD_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.FORGOTPWD_FAILURE, error };
  }
}

function getLoginDetailByToken(tokenIdParams) {
  return dispatch => {
    dispatch(request());

    userService
      .getLoginDetailByToken(tokenIdParams)
      .then(
        data => dispatch(success(data)),
        error => dispatch(failure(error.toString()))
      );
  };

  function request(data) {
    return { type: userConstants.GET_USERLOGIN_BYTOKEN_REQUEST, data };
  }
  function success(data) {
    return { type: userConstants.GET_USERLOGIN_BYTOKEN_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.GET_USERLOGIN_BYTOKEN_FAILURE, error };
  }
}

function reset_Passsword(postData) {
  return dispatch => {
    userService.reset_Passsword(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: userConstants.ResetPasssword_REQUEST, data };
  }
  function success(data) {
    return { type: userConstants.ResetPasssword_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.ResetPasssword_FAILURE, error };
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/actions/user.js